import { module } from 'modujs';
import * as focusTrap from 'focus-trap';

export default class extends module {
    constructor(m) {
        super(m);

        this.$toggler = this.$('toggler')[0];

        this.events = {
            click: {
                toggler: 'toggle'
            }
        }
    }

    init() {
        this.focusTrap = focusTrap.createFocusTrap(this.el, {
            onActivate: this.onActivate,
            onDeactivate: this.onDeactivate,
            clickOutsideDeactivates: true
        });
    }

    destroy() {
        this.focusTrap.deactivate();
    }

    toggle() {
        const isOpen = this.el.parentNode?.classList.contains('is-open');

        if(isOpen) {
            this.focusTrap?.deactivate?.();
        } else {
            this.focusTrap?.activate?.();
        }
    }

    onActivate = () => {
        this.el.parentNode?.classList.add('is-open');
        this.$toggler.setAttribute('aria-expanded', 'true');
    }

    onDeactivate = () => {
        this.el.parentNode?.classList.remove('is-open');
        this.$toggler.setAttribute('aria-expanded', 'false');
    }
}
